import FindIcon from '../findProductsIcon.js';
export default{
    category:[
        {
            id: 1, 
            title : 'Zaštita stoke',
            title_path : 'Zastita stoke',
            img : FindIcon.find('Krave za klanje').img2,
            color : FindIcon.find('Krave za klanje').color,
            size : FindIcon.find('Krave za klanje').size,
            description: `Stoka, kao živa bića koja se kreću, slična čoveku, imaju jako slične probleme tokom rasta i razvoja.
            Bolesti koji su sastavni deo, od onih lakših do težih, usporavaju rast i razvoj, a ako se ne leče na vreme
            dovode do invaliditeta ili smrtnosti. Insekti i razne štetočine, takođe usporavaju rast, i jako je bitno na
            vreme ih primetiti i eliminisati.</br></br>
            Kvalitetno održavati štale i prostorije gde boravi stoka, provetravati svakodnevno, bar jednom godišnje
            krečiti, redovno čistiti ispod stoke, stavljati slamu gde spava stoka, redovno im obezbediti hranu i piće,
            održavati higijenu i čistiti samu stoku, u slučaju bolesti u savetu sa veterinarom davati im antibiotike,
            redovno ih vakcinisati, koristiti razne insekticide protiv raznih insekata koji utiču na loš kvalitet života
            stoke, samo su neki od načina kako zaštititi stoku i dobiti optimalne rezultate.</br></br>
            Preporuka je uvek da se konsultuje i pozove veterinar na svaku primećenost u anomalijama.
            `,
            item_category: 'Stoka'
        },
        {
            id: 1, 
            title : 'Zaštita žitarica',
            title_path : 'Zastita zitarica',
            img : FindIcon.find('Pšenica').img2,
            color : FindIcon.find('Pšenica').color,
            size : FindIcon.find('Pšenica').size,
            description:`
            Žitarice odnosno žita od velike su važnosti za sve ratare i poljoprivredne proizvođače koji žele u vreme
žetve da dobiju dobar, optimalan i kvalitetan rod.</br></br>
Proces rasta, razvoja prate bolesti, korovi, insekti, i zato je veoma bitno voditi računa da se na vreme
primete i spreče.</br></br>
Ukoliko se to ne uradi, rod može umanjen biti i do 80%.
Kvalitetno obrađivati zemljište, izabrati dobro seme, prihranjivati đubrivima (folijarna đubriva), potom
ručno čuvati i pratiti rast, koristiti razne preparate (herbicidi, fungicidi, insekticidi, preparati za tretman
semena) koji utiču na sve bolesti, korove, insekte, samo su neki od načina kako zaštititi žitarice i dobiti
optimalne rezultate.</br></br>
U celom procesu obavezno se posavetovati sa zaštitarom!
            
            `,
            item_category: 'Žitarice'
        },
        
        {
            id: 1, 
            title : 'Zaštita voća',
            title_path : 'Zastita voca',
            img : FindIcon.find('Jabuka').img2,
            color : FindIcon.find('Jabuka').color,
            size : FindIcon.find('Jabuka').size,
            description:`
            Voće su plodovi koji se jedu kao poslastica, u većini slučajeva bez neke dodatne obrade i pravljenja nove
hrane. Voće je bogat izvor raznih vitamina i potrebno ga je jesti svakodnevno. Voće je skoro
svakodnevno na udaru raznih Zaštita, štetočina, korova, i zato se mora jako brzo primetiti da se isti
suzbiju i da na kraju dobijemo kvalitetne plodove.</br></br>
Kvalitetno obrađivati zemljište voćnjaka i prostor oko stabala voća, izabrati dobro seme voća (preparati
za tretman semena), prihranjivati đubrivima voćnjak i stabla (folijarna đubriva), potom ručno čuvati i
pratiti rast voća i cvetova i plodova, koristiti razne preparate i prskati od cveta do ploda (herbicidi,
fungicidi, insekticidi) koji utiču na sve bolesti, korove, insekte, samo su neki od načina kako zaštititi voće i
njegove plodove i dobiti optimalne rezultate.</br></br>
U celom procesu obavezno se posavetovati sa zaštitarom!
            `,
            item_category: 'Voće'
        },
        {
            id: 1, 
            title : 'Zaštita povrća',
            title_path : 'Zastita povrca',
            img : FindIcon.find('Cvekla').img2,
            color : FindIcon.find('Vegetables').color,
            size : FindIcon.find('Vegetables').size,
            description:`
            U povrće spadaju različite biljke, koje se upotrebljavaju u prehrani, bilo sveže (u salati) ili termički obrađene ili konzervisane. Ovisno od vrste za prehranu, upotrebljavaju se cele biljke ili samo pojedini delovi (koren, stabljika ili listovi). Povrće je skoro svakodnevno na udaru raznih Zaštita, štetočina, korova, i zato se mora jako brzo primetiti da se isti suzbiju i da na kraju dobijemo kvalitetne plodove.</br></br>

Kvalitetno obrađivati zemljište, izabrati dobro seme, prihranjivati đubrivima (folijarna đubriva), potom ručno čuvati i pratiti rast, koristiti razne preparate (herbicidi, fungicidi, insekticidi, preparati za tretman semena) koji utiču na sve bolesti, korove, insekte, samo su neki od načina kako zaštititi povrće i dobiti optimalne rezultate.</br></br>
U celom procesu obavezno se posavetovati sa zaštitarom!

            `,
            item_category: 'Povrće'
        }
 

    ]
}
